// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit"
// ** ThemeConfig Import
import themeConfig from "@configs/themeConfig"
export const post = createSlice({
  name: "layout",
  initialState: {
    id: "",
    title: "",
    slug: "",
    tags: [],
    categories: [],
    details: "", // Final HTML post content
    content: [],
    excerpt: "",
    thumbnail: "",
    status: "draft",
    activeWidget: 0,
    addWidgetOpen: false,
    addWidgetOpenIndex: 0,
    stats : {
      isLoading: true,
      isSubmitting : false,
      isError: false,
      errorMessages: [],
    }
  },
  reducers: {
    onFetchStart: (state) => {
      state.stats.isLoading = true
    },
    onPostFetch(state, action) {
      state.title = action.payload.post_title
      state.content = action.payload.content === undefined ? [] : action.payload.content
      state.slug = action.payload.url
      state.excerpt = action.payload.post_excerpt
      state.thumbnail = action.payload.thumbnail
      state.details = action.payload.post_details
      state.status = action.payload.post_status
      state.tags = action.payload.post_tags
      state.id = action.payload.id
      state.relatedPosts = action.payload.related_posts
      state.stats = {
        ...state.stats,
        isLoading: false,
        isError: action.payload.isError,
        errorMessages: action.payload.errorMessages
      }
    },
    onChangePost(state, action) {
      if(action.payload.name === "title"){
        state.slug = action.payload.value.toLowerCase().replace(' ', '-').replace(/[^\w-]+/g,'-')
      }
      state[action.payload.name] = action.payload.value
    },
    addNewWidget: (state, action) => {
      //state.content.push(action.payload)
      state.content.splice(state.addWidgetOpenIndex + 1, 0, action.payload)
      state.addWidgetOpen = false
      state.activeWidget += 1
    },
    updateWidget: (state, action) => {
      state.content[action.payload.index] = action.payload.widget
    },
    deleteWidget: (state, action) => {
      state.content.splice(action.payload, 1)
    },
    changeIndex: (state, action) => {
      // change index of widget
      const widget = state.content[action.payload.index]
      state.content.splice(action.payload.index, 1)
      state.content.splice(action.payload.newIndex, 0, widget)
    },
    setAddWidgetOpen: (state, action) => {
      console.log(action.payload)
        state.addWidgetOpen = action.payload.val
        state.addWidgetOpenIndex = action.payload.index
    },
    setActiveWidget: (state, action) => {
      state.activeWidget = action.payload
    }
}
})
export const {
  onPostFetch,
    onChangePost,
    addNewWidget,
    updateWidget,
    deleteWidget,
    changeIndex,
    setAddWidgetOpen,
    setActiveWidget
} = post.actions
export default post.reducer
